var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop } from 'vue-property-decorator';
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Select.prototype, "curAttrs", {
        // computed
        // 设置默认属性
        get: function () {
            // 设置属性默认值
            return Object.assign({
                clearable: true,
                filterable: Array.isArray(this.options) && this.options.length >= 5,
                multiple: this.multiple,
            }, this.$attrs);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Select.prototype, "curListeners", {
        // 设置事件：清空时设置值为 null
        get: function () {
            var _this = this;
            return Object.assign({}, this.$listeners, {
                clear: function () {
                    var value = _this.multiple ? [] : null;
                    _this.$emit('input', value);
                    _this.$emit('clear');
                    _this.$nextTick(function () {
                        try {
                            // 获取到 input 标签，处理input上的值
                            _this.$refs.select.$children[0].$el.getElementsByTagName('input')[0].value = null;
                        }
                        catch (e) {
                            // console.log(e);
                        }
                    });
                },
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Select.prototype, "selectedLabel", {
        get: function () {
            return this.$refs.select.selectedLabel;
        },
        enumerable: false,
        configurable: true
    });
    /* methods */
    Select.prototype.focusHandle = function () {
        this.$emit('selectFocus', this.$refs.select);
    };
    Select.prototype.focus = function () {
        this.$refs.select.focus();
    };
    __decorate([
        Prop({
            type: String,
            default: 'label',
        })
    ], Select.prototype, "optionLabel", void 0);
    __decorate([
        Prop({
            type: String,
            default: 'value',
        })
    ], Select.prototype, "optionValue", void 0);
    __decorate([
        Prop({
            type: Array,
            default: function () { return []; },
        })
    ], Select.prototype, "options", void 0);
    __decorate([
        Prop({
            type: Array,
            default: function () { return []; },
        })
    ], Select.prototype, "extraOptions", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        })
    ], Select.prototype, "multiple", void 0);
    Select = __decorate([
        Component
    ], Select);
    return Select;
}(Vue));
export default Select;
